<template>
  <nav class="navbar navbar-expand-xl navbar-dark bg-dark">
    <div class="container-fluid d-flex flex-column align-items-stretch">
      <!-- Top Row: Brand, Toggler, and Nav Links -->
      <div class="d-flex align-items-center w-100">
        <router-link class="navbar-brand" to="/">
          <img src="@/assets/logos/viasat-logo-white.png" alt="Viasat" width="95">
          <span class="px-2">NB-NTN Early Adopter Portal</span>
        </router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleSite"
          @click="visible = !visible">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarToggleSite">
          <ul v-if="auth.isAuthenticated" class="navbar-nav ">
            <li class="nav-item">
              <router-link class="nav-link" to="/">Dashboard</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/customers">Customers</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/sims">SIMs</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/apns">APNs</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/devices">Devices</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/messages">Messages</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/coverage">Coverage</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/codecs">Codecs</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/demo">Demo</router-link>
            </li>
            <li v-if="auth.isAdmin" class="nav-item">
              <router-link class="nav-link" to="/users">Users</router-link>
            </li>
          </ul>
          <div v-if="auth.isAuthenticated" class="d-flex align-items-center ms-auto">
            <div class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle text-white"
                id="navbarUserDropdown"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-person-circle me-1"></i>
                {{ auth.userName.split(' ')[0] }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarUserDropdown">
                <li class="text-center">
                  {{ auth.userName }}
                  {{ auth.customerName ? ` (${auth.customerName})` : '' }}
                </li>
                <li v-if="auth.isAdmin">
                  <a class="dropdown-item text-danger" 
                      @click.prevent="clearCache"
                      style="cursor: pointer;"
                  >
                    <i class="bi bi-database-dash me-1"></i>
                    Clear DB Cache
                  </a>
                </li>
                <li>
                  <a class="dropdown-item text-danger" 
                      @click.prevent="handleLogout"
                      style="cursor: pointer;"
                  >
                    <i class="bi bi-box-arrow-right me-1"></i>
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Bottom Row: Time Display -->
      <div v-if="auth.isAuthenticated" class="d-flex justify-content-end w-100 mt-n1 pb-1">
        <div class="time-container">
          <span class="time-text small me-2">
            [<span id="localTime"></span>]
          </span>
          <span id="utcTime" class="time-text text-white small"></span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import { updateTime } from '@/utils/datetime';
import { apiFetch } from '@/utils/api';
import { ApiEndpoint } from '@/utils/config';

const auth = useAuthStore();
const router = useRouter();

const handleLogout = async (event) => {
  event.preventDefault();
  await auth.logout('User logged out');
  router.push({ name: 'Login' });
};

const clearCache = async (event) => {
  event.preventDefault();
  // TODO filter based on page originating request
  const url = ApiEndpoint.DEV + `/clear-cache`;
  const result = await apiFetch(url, { method: 'DELETE' });
  if (result?.deleted) console.debug(`Removed ${result.deleted} cache records`);
};

onMounted(() => {
  setInterval(updateTime, 1000);
  updateTime();
});

</script>

<style scoped>
.time-text {
  /* display: flex; */
  justify-content: flex-end;
  color: gray;
  font-size: 0.75rem;
  font-family: monospace, 'Lucida Console';
}
</style>
